
	export default {
		props: {
			i18n: {
				type: Object,
				required: true
			},
			bridge: {
				type: Object,
				required: true
			},
			moment: {
				type: Function,
				required: true
			},
			domtoimage: {
				type: Object,
				required: true
			},
			data: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				order: null,
				kotDevice: null
			}
		},
		computed: {
			bridgeName () {
				return this.$store.state.bridgeName
			},
			merchant () {
				const parentMerchant = this.$store.state.merchant

				return this.$store.state.settings.receipt.print_child_merchant_details
					? parentMerchant.id === this.data.order.merchant_id
						? parentMerchant
						: parentMerchant.childMerchants?.find(child => child.id === this.data.order.merchant_id) || parentMerchant
					: parentMerchant
			},
			appVersionNumber () {
				return this.$store.getters.appVersionNumber
			},
			employee () {
				return this.$store.state.employee
			},
			settings () {
				return this.$store.state.settings
			},
			printerSettings () {
				return this.$store.state.printerSettings
			},
			printKotAlternateLanguage () {
				return (this.$store.state.locale !== 'ar' && this.$store.state.settings.kot_receipt.print_alternate_language) || !this.$store.state.settings.kot_receipt.print_alternate_language
			}
		},
		beforeMount () {
			this.order = this.data.order
			this.kotDevice = this.data.kot.devices?.find(device => device.id === +this.data.deviceId)
		},
		methods: {
			renderReceipt () {
				const iframe = document.getElementById(this.data.id)
				const iframeDocument = iframe.contentDocument
				const el = iframeDocument.getElementById('receipt')
				const height = el.offsetHeight * this.printerSettings.scaleFactor
				const width = el.offsetWidth * this.printerSettings.scaleFactor

				this.domtoimage.toPng(el, {
					height,
					width
				}).then((dataURL) => {
					if (process.env.NODE_ENV !== 'production') {
						// eslint-disable-next-line
						console.log('%c ', `font-size: 1px; padding: ${Math.floor(height / 2)}px ${Math.floor(width / 2)}px; background: url(${dataURL})`)
					}

					const printData = {
						dataURL,
						printerSettings: {
							...this.printerSettings,
							...this.data.kot
						}
					}

					this.bridge.pushPrinterQueue(this.bridgeName === 'ANDROID' ? this.objToJson(printData) : printData)
				}).catch(console.error).finally(() => {
					this.$emit('destroy')
				})
			}
		}
	}
